import React from 'react';
import './styles.scss'
import ContentLoader from 'react-content-loader';

function EPGSkeleton({contentNoImageProps}) {
    return (
        <ContentLoader
            className='EPGSkeleton'
            viewBox="0 0 400 160"
            height={160}
            width={400}
            speed={1}
            backgroundColor={contentNoImageProps.backgroundColorOne}
            foregroundColor={contentNoImageProps.backgroundColorTwo}
            style={{'height':'100%','width':'100%'}}
        >
            <circle cx="150" cy="75" r="8" />
            <circle cx="194" cy="75" r="8" />
            <circle cx="238" cy="75" r="8" />
        </ContentLoader>
    );
};

export default EPGSkeleton;
